export interface Project {
  title: string;
  description: string;
  image?: string;
  technologies: string[];
  githubUrl: string;
  liveUrl?: string;
  type: string;
}

export const projects: Project[] = [
  {
    title: "Expense Tracker",
    description: "Track expenses with reports and dashboard visualization.",
    technologies: [
      "React",
      "TypeScript",
      "React Router",
      "Redux Toolkit",
      "Material UI",
      "Material UI Icons",
      "Vite",
      "Node.js",
      "Express",
      "Supabase",
    ],
    githubUrl: "https://github.com/cperault/expense-tracker",
    type: "Web Apps",
  },
  {
    title: "ReliefHub",
    description: "A localized disaster relief platform.",
    technologies: [
      "React",
      "TypeScript",
      "React Router",
      "Redux Toolkit",
      "Material UI",
      "Material UI Icons",
      "Vite",
      "Node.js",
      "Express",
      "Firebase Auth/Admin",
      "Cloud Firestore",
      "MapLibre GL",
      "OpenStreetMap",
      "GitHub Actions",
    ],
    githubUrl: "https://github.com/cperault/ReliefHub",
    type: "Web Apps",
  },
  {
    title: "React + Node.js Starter",
    description: "A starter template for a fullstack app.",
    technologies: [
      "React",
      "TypeScript",
      "React Router",
      "Redux Toolkit",
      "Material UI",
      "Material UI Icons",
      "Vite",
      "Node.js",
      "Express",
    ],
    githubUrl: "https://github.com/cperault/react-node-starter",
    type: "Web Apps",
  },
  {
    title: "A Study of SQLite",
    description:
      "A study and rewrite of the SQLite RDBMS engine using Node and TypeScript.",
    technologies: ["TypeScript", "Node.js", "Commander.js"],
    githubUrl: "https://github.com/cperault/sqlite-ts",
    type: "Web Apps",
  },
  {
    title: "Yum Yum",
    description: "A native iOS app for searching and viewing recipes.",
    technologies: ["Swift", "UIKit", "CoreData"],
    githubUrl: "https://github.com/cperault/yum-yum",
    type: "Mobile",
  },
  {
    title: "Q-Trivia",
    description: "A native iOS app for trivia.",
    technologies: ["Swift", "SwiftUI", "CoreData"],
    githubUrl: "https://github.com/cperault/q-trivia",
    type: "Mobile",
  },
];
